<template>
  <div class="question-results-container">
    <div class="question-container">
      <img class="question-image" v-if="question.image" :src="disableCache(question.image)" />
      <h2 v-if="!!question.texts" class="question-text">{{ question.texts[lang] }}</h2>
    </div>
    <div class="answers-container">
      <div
        v-for="(answer, index) in possibleStatsAnswers"
        :key="answer.answerId"
        class="answer-container"
        :class="{ 'correct-answer': answer.isGood }"
      >
        <img v-if="atLeastOneImage" class="image-content" :src="disableCache(getAnswerImage(index))" />
        <div class="answer-bar-container">
          <div class="answer-texts-container" :style="{ color: getAnswerColor(poll, index) }">
            <div class="answer-text break-word">{{ answer.texts[lang] }}</div>
            <div class="answer-percent">{{ getAnswerPercent(answer) }}%</div>
          </div>
          <div
            class="answer-bar-filled"
            :style="{
              width: `${getAnswerPercent(answer)}%`,
              backgroundColor: getAnswerBackgroundColor(poll, index)
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAnswerBackgroundColor, getAnswerColor } from '@/services/ColorService';
import { getPossibleAnswers } from 'polle-shared-formatters';
import { getImagePlaceholder } from '@/services/StyleService';
import { disableCache } from '@/components/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'poll-results',
  props: {
    poll: Object,
    question: Object,
    questionStats: Object
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' }),
    atLeastOneImage() {
      return this.question.answers.some(question => question.image);
    },

    possibleStatsAnswers() {
      return getPossibleAnswers(this.question, this.questionStats.answers);
    }
  },
  methods: {
    getAnswerBackgroundColor,
    getAnswerColor,
    disableCache,

    getAnswerPercent(answer) {
      if (this.questionStats.totalVoteCount === 0) {
        return 0;
      }
      return Math.round((answer.voteCount * 100) / this.questionStats.totalVoteCount);
    },

    getAnswerImage(index) {
      return this.question.answers[index].image || getImagePlaceholder();
    }
  }
};
</script>

<style lang="scss" scoped>
.back-banner {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  color: #fff;
  background-color: #333;
  height: 50px;
  line-height: 50px;
}

.question-results-container {
  margin: 0 20px;
  transition: height 2s;
}

.triangle {
  transform: rotate(180deg);
  width: 20px;
  right: 10px;
  float: right;
  margin-right: 10px;
  line-height: 50px;
  margin-top: 16px;
}

.question-container {
  display: flex;
  align-items: center;
}

.question-image {
  width: 70px;
  display: flex;
  flex: 0 0 70px;
  height: 100%;
}

.question-text {
  margin-left: 10px;
}

.answers-container {
}

.answer-container {
  margin-top: 10px;
  display: flex;
}

.image-content {
  display: flex;
  flex: 0 0 38px;
  margin-right: 5px;
  height: 38px;
}

.answer-bar-container {
  flex: 1;
  position: relative;
  background-color: #d8dadd;
}

.answer-bar-filled {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  transition: all 2s;
}

.answer-texts-container {
  display: flex;
  width: 100%;
  margin: 0 10px;
  & > div {
    z-index: 1;
  }
  justify-content: center;
  align-items: center;
}

.answer-text {
  flex: 1;
  margin: 10px 0px;
}

.answer-percent {
  margin-right: 15px;
  width: 50px;
  flex: 0 0 50px;
  text-align: right;
}
</style>
